import { useCallback, useEffect, useRef } from "react";
import _ from "lodash";
import * as api from "@form/services/iframesdk";

function callback(callbackId: any, data: any, error?: any) {
  if (!callbackId) {
    return;
  }
  if (!parent) {
    return;
  }
  const origin = new URL(window.location.href).origin;
  if (error) {
    parent.postMessage(
      {
        type: "callback_resp",
        callbackId,
        error: error.message,
      },
      origin
    );
  } else {
    parent.postMessage(
      {
        type: "callback_resp",
        callbackId,
        data: data,
      },
      origin
    );
  }
}

export default function useEditMessage(context: any) {
  const contextRef = useRef({});

  useEffect(() => {
    contextRef.current = context;
    parent &&
      parent.postMessage(
        {
          type: "context_change",
          data: JSON.stringify(context),
        },
        "*"
      );
  }, [context]);

  const handleMessage = useCallback(
    async (e: any) => {
      let result;
      const callbackId = _.get(e.data, "callbackId");
      try {
        if (e.origin === "http://localhost:3001") {
          console.log("handleMessage", e);
          const type = _.get(e.data, "type");
          if (type === "api") {
            const method = _.get(e.data, "method");
            const data = _.get(e.data, "data");
            // @ts-ignore
            if (!api[method]) {
              throw new Error(`${method} not support`);
            }
            // @ts-ignore
            result = await api[method].apply(contextRef.current, data);
          }
          if (type === "init") {
            result = {
              apiList: Object.keys(api),
            };
          }
          if (typeof result !== "undefined") {
            callback(callbackId, result);
          }
        }
      } catch (e) {
        console.error(e);
        callback(callbackId, undefined, e);
      }
    },
    [contextRef]
  );

  useEffect(() => {
    window.addEventListener("message", handleMessage, false);
    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, []);
}
